import "./hobbies.css";

export function Hobbies() {
  return (
    <section className="hobbies">
      <div className="hobbies__pics">
        <img src="./yoga.png" alt="Scene of Yoga" />
        <img src="./cats.png" alt="Scene of Yoga" />
        <img src="./diy.png" alt="Scene of Yoga" />
      </div>
      <div className="hobbies__pics">
        <img src="./typewriter.png" alt="Scene of Yoga" />
        <img src="./series.png" alt="Scene of Yoga" />
        <img src="./drawing.png" alt="Scene of Yoga" />
      </div>
    </section>
  );
}
